import { render } from "./ErrorMessage.vue?vue&type=template&id=5c8113b0&ts=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts"

import "./ErrorMessage.vue?vue&type=style&index=0&id=5c8113b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__